import { Box, Center, HStack, Text } from "@chakra-ui/react";
import { CampaignAutodiscoveryStatus } from "@intentsify/types";
import { Progress } from "components";
import { FiSettings } from "react-icons/fi";

const AutodiscoveryActionLabel = ({
  status,
}: {
  status: CampaignAutodiscoveryStatus;
}) => {
  const label =
    status === CampaignAutodiscoveryStatus.ERROR
      ? "Retry"
      : status === CampaignAutodiscoveryStatus.PROCESSED
        ? "Reprocess"
        : "Process";

  return (
    <HStack>
      <FiSettings />
      <Text>{label}</Text>
    </HStack>
  );
};

const AutodiscoveryProgress = () => {
  return (
    <Box>
      <Center>
        <Text size="lg" fontWeight="semibold">
          Processing...
        </Text>
      </Center>
      <Progress hasStripe colorScheme={"blue"} isIndeterminate />
    </Box>
  );
};

export { AutodiscoveryActionLabel, AutodiscoveryProgress };
